import React from 'react';
import { FiCheck, FiX, FiInfo } from 'react-icons/fi';
import Shade from "../assets/NewHome/shade.png";
const ComparisonTable = () => {
  const [tooltipState, setTooltipState] = React.useState({ visible: false, text: '', x: 0, y: 0 });

  const handleTooltipMouseEnter = (e, tooltipText) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setTooltipState({
      visible: true,
      text: tooltipText,
      x: rect.right + 10,
      y: rect.top + rect.height / 2
    });
  };

  const handleTooltipMouseLeave = () => {
    setTooltipState({ visible: false, text: '', x: 0, y: 0 });
  };

  // Add shimmer + shade keyframes to document
  React.useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes shimmer {
        0% {
          background-position: 200% 200%;
        } 
        100% {
          background-position: -200% -200%;
        }
      }
      @keyframes shadeMove {
        0% {
          transform: translate(-40%, 0%) scale(1);
        }
        50% {
          transform: translate(40%, 0%) scale(1);
        }
        100% {
          transform: translate(-40%, 0%) scale(1);
        }
      }
      .shimmer-text {
        background: linear-gradient(90deg, #60a5fa 0%, #60a5fa 30%, #ffffff 50%, #60a5fa 70%, #60a5fa 100%);
        background-size: 200% 100%;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        animation: shimmer 4s linear infinite;
        display: inline-block;
      }
      .tooltip-container {
        position: relative;
        display: inline-flex;
        align-items: center;
      }
      .tooltip-icon {
        cursor: help;
        margin-left: 6px;
        color: #6b7280;
        transition: color 0.2s;
      }
      .tooltip-icon:hover {
        color: #3b82f6;
      }
      .tooltip-text {
        position: fixed;
        background-color: #1f2937;
        color: #ffffff;
        text-align: left;
        padding: 8px 12px;
        border-radius: 6px;
        font-size: 12px;
        font-family: 'Bricolage Grotesque', sans-serif;
        z-index: 9999;
        pointer-events: none;
        max-width: 250px;
        white-space: normal;
        width: max-content;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
        transform: translateY(-50%);
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.3s, visibility 0.3s;
      }
      .tooltip-text.visible {
        opacity: 1;
        visibility: visible;
      }
      .tooltip-text::after {
        content: "";
        position: absolute;
        left: -5px;
        top: 50%;
        transform: translateY(-50%);
        border-width: 5px;
        border-style: solid;
        border-color: transparent #1f2937 transparent transparent;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);
  const features = [
    {
      category: 'Sales and account intelligence',
      tooltip: 'Keep track of your target accounts, industries, market and people.',
      whiteowl: 'Yes',
      chatgpt: false,
      claude: false,
      perplexity: false,
      copilot: false
    },
    {
      category: 'Lead signals to inbox',
      tooltip: 'Get lead signals about funding, M&A, leadership changes and more.',
      whiteowl: 'Yes',
      chatgpt: false,
      claude: false,
      perplexity: false,
      copilot: false
    },
    {
      category: 'Opportunity validation',
      tooltip: 'Evaluate an opportunity better to determine if it is worth investing your time.',
      whiteowl: 'Yes',
      chatgpt: false,
      claude: false,
      perplexity: 'Base',
      copilot: false
    },
    {
      category: 'People discovery',
      tooltip: 'Find relevant people to connect with based on the lead signal.',
      whiteowl: 'Yes',
      chatgpt: false,
      claude: false,
      perplexity: false,
      copilot: false
    },
    {
      category: 'Personalised pitch generation',
      tooltip: 'Generate personalised emails based on the signal and your consulting offerings.',
      whiteowl: 'Yes',
      chatgpt: 'Yes',
      claude: 'Yes',
      perplexity: 'Yes',
      copilot: 'Yes'
    },
    {
      category: 'Lookalike accounts & watchlists',
      tooltip: 'Identify new potential clients similar to existing accounts. Create a watchlist of people & companies you want to monitor.',
      whiteowl: 'Yes',
      chatgpt: false,
      claude: false,
      perplexity: false,
      copilot: false
    },
    {
      category: 'AI web search',
      tooltip: 'Conduct LLM-based qualitative research to generate insights.',
      whiteowl: 'Yes',
      chatgpt: 'Yes',
      claude: 'Yes',
      perplexity: 'Yes',
      copilot: false
    },
    {
      category: 'Document creation with in-built Copilot',
      tooltip: 'Create outlines and iterate with an inline AI copilot to improve drafts.',
      whiteowl: 'Yes',
      chatgpt: false,
      claude: false,
      perplexity: false,
      copilot: false
    },
    {
      category: 'Custom templates for research & docs',
      tooltip: 'Get structured outputs that align with your brand.',
      whiteowl: 'Yes',
      chatgpt: 'Yes',
      claude: false,
      perplexity: false,
      copilot: 'Yes'
    },
    {
      category: 'Company knowledge profile',
      tooltip: 'Consulting firms\' knowledge profile based on the website, documents and past projects.',
      whiteowl: 'Advanced',
      chatgpt: 'Base',
      claude: 'Base',
      perplexity: 'Base',
      copilot: 'Yes'
    },
    {
      category: 'Proposal presentation',
      tooltip: 'Get PowerPoint presentations for proposals.',
      whiteowl: 'Coming Soon',
      chatgpt: false,
      claude: false,
      perplexity: false,
      copilot: false
    },
    {
      category: 'Team collaboration',
      tooltip: 'Share signals and insights. Comment and collaborate.',
      whiteowl: 'Coming Soon',
      chatgpt: false,
      claude: false,
      perplexity: false,
      copilot: false
    },
    {
      category: 'Integration',
      tooltip: 'CRM, Email and Calendar.',
      whiteowl: 'Coming Soon',
      chatgpt: 'Yes',
      claude: 'Yes',
      perplexity: 'Limited',
      copilot: false
    }
  ];

  const renderCell = (value) => {
    if (value === false) {
      return (
        <div className="flex items-center justify-center">
          <FiX className="w-4 h-4 text-red-500" strokeWidth={2.5} />
        </div>
      );
    }
    
    if (value === 'Yes') {
      return (
        <div className="flex items-center justify-center gap-1.5">
          <FiCheck className="w-6 h-6 p-1 text-blue-500 rounded-md flex-shrink-0" strokeWidth={2.5} />
        </div>
      );
    }
    
    if (value === 'Coming Soon') {
      return (
        <span 
          className="text-sm font-normal shimmer-text" 
          style={{ 
            fontFamily: 'Bricolage Grotesque, sans-serif'
          }}
        >
          Coming Soon
        </span>
      );
    }

    if (value === 'Advanced' || value === 'Base' || value === 'Limited') {
      // Plain text (no capsule) but keep previous colors per level
      const textColorMap = {
        Advanced: 'text-blue-800',
        Base: 'text-blue-700',
        Limited: 'text-amber-700',
      };

      return (
        <span
          className={`text-sm font-semibold ${textColorMap[value] || 'text-gray-900'}`}
          style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}
        >
          {value}
        </span>
      );
    }

    return (
      <span className="text-sm text-gray-900 font-normal" style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}>
        {value}
      </span>
    );
  };

  return (
    <section className="pt-12 pb-36 bg-white">
      <div className="max-w-7xl lg:max-w-[1200px] xl:max-w-[1300px] mx-auto px-20">{/* Table */}
        <div className="overflow-x-auto px-20 pt-0 space-y-20 rounded-[35px] mt-12 relative">
          {/* Moving shade image behind the table (not on the table background) */}
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl w-full text-center font-normal text-gray-900 mb-2 sm:mb-3" style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}>
            What sets us apart?
          </h2>
          <div className="pointer-events-none absolute -top-20  flex items-center justify-center overflow-hidden">
              <div 
                className="relative rounded-full"
                style={{
                  width: '50%',
                  animation: 'shadeMove 10s ease-in-out infinite',
                }}
              >
                <img
                  src={Shade}
                  alt=""
                  className="w-full h-auto rounded-full"
                  style={{
                    filter: 'blur(20px)',
                    opacity: 0.8,
                  }}
                />
                {/* Subtle white gradient overlay to blend with white background */}
                <div 
                  className="absolute inset-0 rounded-full"
                  style={{
                    background: 'radial-gradient(ellipse, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0.1) 50%, transparent 100%)',
                  }}
                />
              </div>
          </div>
          <table
            className="relative w-full border-collapse rounded-[35px] shadow-sm overflow-hidden bg-white"
          >
            <thead>
              <tr className="border-b-2 border-gray-200">
                <th className="px-4 sm:px-6 py-3 sm:py-4 text-left text-xs sm:text-sm font-medium text-gray-900" style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}>
                  Features
                </th>
                <th className="px-4 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm font-medium text-gray-900" style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}>
                  WhiteOwl
                </th>
                <th className="px-4 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm font-medium text-gray-900" style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}>
                  ChatGPT
                </th>
                <th className="px-4 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm font-medium text-gray-900" style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}>
                  Claude
                </th>
                <th className="px-4 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm font-medium text-gray-900 whitespace-nowrap" style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}>
                  Perplexity
                </th>
                {/* <th className="px-4 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm font-medium text-gray-900 whitespace-nowrap" style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}>
                  Microsoft Copilot
                </th> */}
              </tr>
            </thead>
            <tbody>
              {features.map((feature, index) => (
                <tr
                  key={index}
                  className="border-b border-gray-150 hover:bg-white/10 bg-white transition-colors"
                >
                  <td className="px-4 sm:px-6 py-3 sm:py-4 text-sm font-extralight text-gray-900" style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}>
                    <div className="tooltip-container">
                      <span>{feature.category}</span>
                      <FiInfo 
                        className="tooltip-icon w-4 h-4 flex-shrink-0" 
                        onMouseEnter={(e) => handleTooltipMouseEnter(e, feature.tooltip)}
                        onMouseLeave={handleTooltipMouseLeave}
                      />
                    </div>
                  </td>
                  <td className="px-4 sm:px-6 py-3 sm:py-4 text-center">
                    {renderCell(feature.whiteowl)}
                  </td>
                  <td className="px-4 sm:px-6 py-3 sm:py-4 text-center">
                    {renderCell(feature.chatgpt)}
                  </td>
                  <td className="px-4 sm:px-6 py-3 sm:py-4 text-center">
                    {renderCell(feature.claude)}
                  </td>
                  <td className="px-4 sm:px-6 py-3 sm:py-4 text-center">
                    {renderCell(feature.perplexity)}
                  </td>
                  {/* <td className="px-4 sm:px-6 py-3 sm:py-4 text-center">
                    {renderCell(feature.copilot)}
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {tooltipState.visible && (
        <div 
          className="tooltip-text visible"
          style={{
            left: `${tooltipState.x}px`,
            top: `${tooltipState.y}px`
          }}
        >
          {tooltipState.text}
        </div>
      )}
    </section>
  );
};

export default ComparisonTable;
